export default __webpack_public_path__ + "images/RY.3878bf8.png";